'use client';

import { Stack, Typography } from '@mui/material';
import Image from 'next/image';

import { backgrounds } from '@/assets/materials';

export const AboutUsSection2 = () => {
  return (
    <Stack
      width={'100%'}
      height={'100%'}
      flexGrow={1}
      paddingX={{ xs: '24px', md: '80px' }}
      paddingTop={{ xs: '130px', md: '180px' }}
      paddingBottom={{ xs: '32px', md: '180px' }}
      alignItems={'center'}
      justifyContent={'center'}
      component={'section'}
      position={'relative'}
      bgcolor={'#0A0D16'}>
      <Stack
        zIndex={3}
        position={'relative'}
        direction={{ xs: 'column', md: 'row-reverse' }}
        justifyContent={'space-between'}
        width={'min(1280px, 100%)'}
        alignItems={{ xs: 'center', md: 'flex-start' }}>
        <Stack width={'100%'} maxWidth={'626px'} zIndex={3}>
          <Typography
            fontSize={{ xs: '14px', sm: '18px' }}
            variant={'bodyLarge'}
            color={'#FFFFFF'}
            whiteSpace={'pre-line'}
            className={'mix-blend'}>
            {`In a rapidly evolving digital landscape, LFG stands at the forefront of the next wave of digital innovation. We are committed to fostering a vibrant ecosystem that extends beyond any single company, pushing the boundaries of what's possible in technology.
            \n\n By supporting external innovators, LFG is uniquely positioned to catalyze growth, offering unparalleled guidance and resources to help shape the future of digital products and platforms. We invite forward-thinking investors to join us in this journey to redefine the digital frontier.
            \n\n LFG Incorporated Limited is domiciled in Hong Kong.
            `}
          </Typography>
        </Stack>

        {/* Right side app UI image */}
        <Stack
          position={{ xs: 'relative', md: 'absolute' }}
          left={{ md: '-230px' }}
          top={{ md: '-110px' }}
          width={{ xs: '100%', md: '50%', lg: '45%' }}
          mt={{ xs: 6, md: 0 }}
          alignSelf={{ xs: 'center', md: 'flex-start' }}
          zIndex={2}>
          <Image
            priority
            src={backgrounds.about_us_sect_2}
            alt='LFG Core Launchpad Interface'
            width={824}
            height={569}
            className={'w-[420px] h-[285px] sm:w-[824px] sm:h-[560px] object-contain'}
          />
        </Stack>
      </Stack>
    </Stack>
  );
};
